<template lang="pug">
.avatar-adult
  template(v-if="getAdultAdded.length>0")
    .avatar
      img(:src="getAdultAdded[0].avatar")
    .nickname {{getAdultAdded[0].nickname? getAdultAdded[0].nickname : '家人'}}
    .member
      member(:grade="getAdultAdded[0].grade")
    ghost-btn(:copy="$t('btn.delete')" @clicked="onRemove")
  template(v-if="!noAdd && getAdultAdded.length===0")
    icon-add(@add="onAdd")
    .copy 添加成人

</template>
<script>
import Member from '@/components/wedgits/Member'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import IconAdd from '@/views/Me/IconAdd'
import GhostBtn from '@/components/wedgits/GhostBtn'
export default {
  name: 'AvatarAdult',
  components: { GhostBtn, IconAdd, Member },
  props: {
    noAdd: {
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('app', ['fam', 'user']),
    ...mapGetters('app', ['getAdultAdded']),
  },
  methods: {
    ...mapActions('app', ['RemoveSubUser', 'GetUser']),
    ...mapMutations('app', ['setRouterBack', 'setPending']),
    onAdd() {
      this.setRouterBack('/me/fam')
      this.$router.replace('/me/addAdult')
    },
    onRemove() {
      let payload = {
        userId: this.user.id,
        subUserId: this.getAdultAdded[0].id,
      }
      this.setPending(true)
      this.RemoveSubUser(payload).then((res) => {
        console.log(res)
        this.GetUser(this.user.id).then((res) => {
          this.setPending(false)
        })
      })
    },
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.avatar-adult
  width: 100%
  height: 100%
  display: flex
  align-items: center
  justify-content: center
  flex-direction: column

  .avatar
    width: pxToRem(180)
    height: pxToRem(180)
    border-radius: pxToRem(90)
    //background: #1664FF
    overflow: hidden
    img
      width: 100%
  .nickname
    margin-top: pxToRem(20)
    font-size: pxToRem(36)
    font-family: $ff-cn
    line-height: pxToRem(50)
    font-weight: bold
    letter-spacing: pxToRem(0.8)
  .member
    line-height: 0
    margin-top: pxToRem(5)
    width: pxToRem(146)
    height: pxToRem(32)
  .ghost-btn
    margin: pxToRem(60) 0 0 0
  .icon-add
  .copy
    font-size: pxToRem(36)
    color: $cl-blue
</style>
